/* eslint-disable camelcase */
import { useState, useEffect } from "react";
import {
    getClinicianAvailabilityData,
    getClinicianAvailabilityInitFilters,
    getSelfMatchingFilters,
} from "../../../redux/services/questionnaireServices";

import ClicianAvailability from "./ClinicianAvailability";
import _ from "lodash";
import { deepClone } from "../../../utils/helpers";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Logger } from "src/services";
import { CombinedFiltersToApply } from "../Modals/ApplyFilterContainer";
import { getAvailibilityFilter, getScheduleFilter, getSearchCADataFilter } from "../Services/FilterHelperService";
import { useIsMobile, usePrevious } from "src/latest/src/hooks";
import { updateCombinedFilters } from "src/redux/actions/questionnaireActions";
import { GroupSlotsBasedOnDate, getTimeAsPerBlackoutHours, SearchMatchScoreResponse, GetUserTimeZone, ConvertUTCDatesBasedOnTimeZone, getStartDateAndTime } from "src/latest/src";
import { useSearchParams } from 'react-router-dom';


type Props = {
    choices?: any,
    selectedUserId?: string,
    isFromQuestionnaire?: boolean,
    handleOnclick?: Function
};

export default function ClinicianAvailabilityContainer({
    choices,
    selectedUserId,
    isFromQuestionnaire = false,
    handleOnclick,
}: Props): React$Element<any> {
    // TODO: so many local state variables, worth creating a reducer of local state
    const dispatch = useDispatch();
    const [init, setInit] = useState(false);
    const [searchUpdatedFilter, setSearchUpdatedFilter] = useState([]); // filters that are applied by user
    const [isLoading, setIsLoading] = useState(true);
    const [therapistLoading, setTherapistLoading] = useState(false);
    const [therapistsList, setTherapistsList] = useState([]);
    const [dateRequested, setDateRequested] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({}); // filters that are coming from API
    const [offset, setOffset] = useState(0);
    // eslint-disable-next-line no-unused-vars
    const [total, setTotal] = useState(0);

    let [scheduleFilterObject, setScheduleFilterObject] = useState();
    const [searchCAData, setSearchCAData] = useState({});
    const [previousSearchCAData, setPreviousSearchCAData] = useState({});
    const previousFilter = usePrevious(scheduleFilterObject);
    const [selectedTherapist, setSelectedTherapist] = useState(null);
    const previousSelectedTherapist = usePrevious(selectedTherapist);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalNoOfPages, setTotalNoOfPages] = useState();
    const calenderServiceFilters = ["meetingPreference", "serviceType"];
    const [CSOffset, setCSOffset] = useState(0);
    const [combindFilters, setCombindFilters] = useState({});
    const [offsetCall, setOffsetCall] = useState(false);
    const { loggedInUser } = useSelector((state) => state?.authentication);
    const selfUserId = useSelector((state) => state?.questionnaireData?.initialMetadata?.user_id);
    const isScheduler = (
        loggedInUser &&
        Object.entries(loggedInUser)?.length > 0 &&
        (loggedInUser?.user_type?.includes("SCHEDULER") ||
            loggedInUser?.user_type?.includes("PRACTICE_ADMIN"))
    );
    const [isWithEmptySlot, setIsWithEmptySlot] = useState(null);
    const isFromBookingPage = localStorage.getItem("isFromBookingPage");
    const isFromMobile = useIsMobile();
    const forDays = isFromMobile ? 3 : 5;
    const fromBookingClientId = localStorage.getItem("clientId");
    const selfUserIdFromStorage = localStorage.getItem("self-user-id");
    // this selfUserIdFromStorage a hack, as there was a bug happening where somehow selfUserId from redux getting null
    // couldn't figureout the exact reason as it happens selectively.
    const { blackoutHours, blackoutDays, practiceTimeZone } = useSelector(
        (state: any) => state?.configuration
    );
    let isSelfMatchFlow: Boolean = false;

    const reloadFilters: Boolean = useSelector(
        (state) => state?.questionnaireData?.currentConfig?.reloadFilters
    );

    const [selectedOption, setSelectedOption] = useState('MOST');


    const handleSelect = (option) => {
        if (selectedOption === option) {
            return;
        }

        setSelectedOption(option);
    };

    useEffect(() => {
        if (!selectedOption || !combindFilters?.schedule_request?.service_type) return;

        const fetchData = async () => {
            try {
                const updatedFilters = {
                    ...scheduleFilterObject,
                    sort_by: selectedOption,
                };

                setScheduleFilterObject(updatedFilters);

                setCombindFilters({
                    ...combindFilters,
                    schedule_request: updatedFilters,
                });

                Logger.log(`API called with sort option: ${selectedOption}`);
            } catch (error) {
                Logger.error("Error calling getClinicianAvailabilityData API:", error);
            }
        };

        fetchData();
    }, [selectedOption]);


    useEffect(() => {
        prepareData();

        return localStorage.removeItem("clientId");
    }, []);

    useEffect(() => {
        if (reloadFilters) {
            setIsLoading(true);

            prepareData();
        }
    }, [reloadFilters]);

    const prepareData = async () => {
        await getFilters();

        setIsLoading(false);
    };

    const [searchParams] = useSearchParams();

    const getFilters = async () => {
        isSelfMatchFlow = ((isFromQuestionnaire === true || selectedUserId || selfUserId || selfUserIdFromStorage || isFromBookingPage) && !isScheduler);
        const filters = isSelfMatchFlow
            ? await getSelfMatchingFilters(
                selectedUserId ||
                selfUserId ||
                selfUserIdFromStorage ||
                fromBookingClientId, searchParams
            )
            : await getClinicianAvailabilityInitFilters();

        filters.filters = filters.filters.sort(
            (a, b) => a.sequence - b.sequence
        );
        setSelectedFilters(filters);

        const startDateAndTime = getTimeAsPerBlackoutHours(
            new Date(),
            blackoutHours,
            blackoutDays,
            !isFromQuestionnaire ? practiceTimeZone : '',
        );

        // CALENDAR SERVICE FILTER PRESELECT
        const preFilters = deepClone(filters);

        const calenderFilters = filters.filters
            .filter((filter) =>
                calenderServiceFilters.includes(filter.filter_key)
            )
            .filter((filter) =>
                filter.filter_selection_data.filter(
                    (filterobj) => filterobj.selected === true
                )
            );


        const initCalendarFilter = {
            start_date: startDateAndTime,
            callAPI: true,
            time_from: null,
            time_until: null,
            schedule_day: [],
            schedules_with_slots: isScheduler,
            for_days: forDays,
            user_time_zone: !isFromQuestionnaire && practiceTimeZone ? practiceTimeZone : GetUserTimeZone(),
            sort_by: selectedOption || "EARLIEST",
        };

        // changed .map() to .forEach() below to remove the eslint warnings.
        calenderFilters.forEach((filter) => {
            if (filter.filter_key === "serviceType") {
                // changed .map() to .forEach() below to remove the eslint warnings.
                filter.filter_selection_data.forEach((selectionData) => {
                    if (selectionData.selected === true) {
                        initCalendarFilter.service_type = selectionData.unique_key;
                    }
                });
            }

            if (filter.filter_key === "meetingPreference") {
                // changed .map() to .forEach() below to remove the eslint warnings.
                filter.filter_selection_data.forEach((selectionData) => {
                    if (selectionData.selected === true) {
                        initCalendarFilter.meeting_pref = [
                            selectionData.unique_key,
                        ];
                    }
                });
            }

            if (filter.filter_key === "ageGroup") {
                let ageGroup = [];
                const currentFilter = deepClone(filter);

                // changed .map() to .forEach() below to remove the eslint warnings.
                filter.filter_selection_data.forEach((selectionData) => {
                    if (selectionData.selected === true) {
                        const ageRange = selectionData.label
                            .replace(" years old", "")
                            .replace(/\s+/g, "")
                            .replace("—", "-");

                        if (ageGroup === "65+") {
                            ageGroup = "65-100";
                        }

                        ageGroup.push(ageRange);
                    }
                });
                initCalendarFilter.age_range = ageGroup;
                currentFilter.filter_selection_data =
                    filter.filter_selection_data.filter(
                        (choice) => choice.selcected
                    );
            }
        });
        setScheduleFilterObject(initCalendarFilter);

        const questionnaireFilters = preFilters.filters
            .filter(
                (filter) =>
                    !calenderServiceFilters.includes(filter.filter_key) ||
                    filter.filter_key === "ageGroup" ||
                    filter.filter_key === "clientLocation"
            )
            .map((filter) => {
                if (filter.filter_key !== "clientLocation") {
                    filter.filter_selection_data =
                        filter.filter_selection_data.filter(
                            (choice) => choice.selected === true
                        );
                }

                return filter;
            })
            .filter((filter) => filter.filter_selection_data.length !== 0);

       
        setSearchUpdatedFilter(questionnaireFilters);
        setCombindFilters({
            filters: questionnaireFilters,
            schedule_request: initCalendarFilter,
            therapist_id: "",
            is_clinician_availability_page: isScheduler,
        });
        setInit(true);
    };

    useEffect(() => {
        if (
            Object.keys(combindFilters).length > 0
        ) {
            _showClinicianFilteredData();
        }
    }, [combindFilters]);

    useEffect(() => {
        const updatedScheduleFilterObject = {
            ...scheduleFilterObject,
            schedules_with_slots: isScheduler
                ? !isWithEmptySlot
                : isWithEmptySlot,
        };

        setScheduleFilterObject(updatedScheduleFilterObject);
    }, [isWithEmptySlot]);

    const handleScheduleFilterUpdate = async (
        filter,
        selectedValue,
        currentFilter
    ) => {
        const _scheduleFilterData =
            getScheduleFilter(scheduleFilterObject, selectedTherapist, {
                filter,
                selectedValue,
                currentFilter,
            }) || scheduleFilterObject;

        setScheduleFilterObject(_scheduleFilterData);
    };

    useEffect(async () => {
        if (
            !_.isEqual(previousSearchCAData?.filters, searchCAData?.filters) &&
            init === true &&
            isFromMobile === false
        ) {
            setPreviousSearchCAData(deepClone(searchCAData));

            setCombindFilters({
                ...combindFilters,
                filters: searchCAData.filters,
            });
        }
    }, [searchCAData]);

    const handleDateSliderChange = (date) => {
        const dateInit = new Date(date);

        if (
            !moment(dateInit).isSame(scheduleFilterObject.start_date, "day") ||
            (isFromQuestionnaire === false &&
                window.location.pathname.includes("clinician-availability") &&
                isFromBookingPage === null)
        ) {
            let updatedScheduleFilterObject;

            if (selectedTherapist && selectedTherapist !== "") {
                updatedScheduleFilterObject = {
                    ...scheduleFilterObject,
                    start_date: date,
                    therapist_ids: [selectedTherapist],
                };
            } else {
                updatedScheduleFilterObject = {
                    ...scheduleFilterObject,
                    start_date: date,
                };
            }

            setScheduleFilterObject(updatedScheduleFilterObject);
            applyCombinedFiltersForScheduleFilterUpdates(
                updatedScheduleFilterObject
            );
        }
    };

    useEffect(() => {
        if (
            !isEqualObjects(
                deepClone(previousFilter),
                deepClone(scheduleFilterObject)
            ) &&
            scheduleFilterObject.callAPI === true &&
            init === true &&
            isFromMobile === false
        ) {
            setCombindFilters({
                ...combindFilters,
                schedule_request: scheduleFilterObject,
            });
        }
    }, [scheduleFilterObject]);

    const applyCombinedFiltersForScheduleFilterUpdates = (
        scheduleFilterObject
    ) => {
        // as we need to apply filters on a click of apply button
        // We have disabled auto update of combined filters when we are on mobile.
        // some filters are not applied through mobile filter modal
        // in those cases we need to apply them specifically so that
        // API call can happen for those filters.
        if (
            isFromMobile &&
            !isEqualObjects(
                deepClone(combindFilters?.schedule_request),
                deepClone(scheduleFilterObject)
            )
        ) {
            setCombindFilters({
                ...combindFilters,
                schedule_request: scheduleFilterObject,
            });
        }
    };

    const isEqualObjects = (obj1, obj2) => {
        const date1 = moment(obj1?.start_date);
        const date2 = moment(obj2?.start_date);
        const isSameDay = date1.isSame(date2, "day");

        if (!isSameDay) {
            return false;
        }

        delete obj1?.start_date;
        delete obj2?.start_date;

        return _.isEqual(obj1, obj2);
    };

    const _showClinicianFilteredData = async (givenOffset = 0, combindFiltersParam) => {
        // TODO: add loader
        setTherapistLoading(true);
        const _combinedFilters = deepClone(combindFiltersParam || combindFilters);

        // TODO: add to redux state
        dispatch(updateCombinedFilters(_combinedFilters));
        const _clientId = isFromQuestionnaire ? selfUserId || selfUserIdFromStorage : loggedInUser.id;

        if (!_clientId) {
            return;
        }

        const payload = { ..._combinedFilters, ...{ client_id: _clientId } };

        const clinicianAvailabilityData: SearchMatchScoreResponse = await getClinicianAvailabilityData(
            payload,
            10,
            givenOffset,
        );

        const { date_requested_utc } = clinicianAvailabilityData;
        const datesRequested = date_requested_utc;

        const formatedDateRequested = ConvertUTCDatesBasedOnTimeZone(datesRequested, !isFromQuestionnaire && practiceTimeZone ? practiceTimeZone : undefined);

        clinicianAvailabilityData.match_scores = GroupSlotsBasedOnDate(clinicianAvailabilityData, practiceTimeZone, !isFromQuestionnaire);

        const foundTherapists = clinicianAvailabilityData.match_scores;

        setTherapistsList(foundTherapists); // therapists to show on the screen
        setDateRequested(formatedDateRequested);
        setTotal(clinicianAvailabilityData.total);
        const totalPages = Math.ceil(clinicianAvailabilityData.total / 10);

        setTotalNoOfPages(totalPages);
        // TODO: remove loader
        setTherapistLoading(false);
        setOffsetCall(false);

        if (givenOffset === 0) {
            setCSOffset(0);
            setCurrentPage(1);
        }
    };

    const handleAvailabilityFilter = (filters) => {
        if (init === true) {
            setScheduleFilterObject(getAvailibilityFilter(scheduleFilterObject, filters));
        }
    };

    useEffect(async () => {
        if (!_.isEqual(searchUpdatedFilter, searchCAData?.filter)) {
            const finalUpdate = [...searchUpdatedFilter];

            if (
                searchUpdatedFilter.length > 0 &&
                (selectedTherapist === "" ||
                    selectedTherapist === undefined ||
                    selectedTherapist === null)
            ) {
                setSearchCAData({
                    ...searchCAData,
                    filters: [...finalUpdate],
                    therapist_ids: [],
                });
            } else {
                setSearchCAData({
                    ...searchCAData,
                    filters: [...finalUpdate],
                });
            }
        }
    }, [searchUpdatedFilter]);

    const onSelectedTherapist = async (search) => {
        if (
            (previousSelectedTherapist || search?.id) &&
            !_.isEqual(previousSelectedTherapist, search?.id)
        ) {
            setSelectedTherapist(search?.id);

            if (search) {
                // setScheduleFilterObject({
                //     ...scheduleFilterObject,
                //     therapist_ids: [search?.id],
                // });
                setCombindFilters({
                    ...combindFilters,
                    therapist_id: search?.id,
                });

            } else {
                // setScheduleFilterObject({
                //     ...scheduleFilterObject,
                //     therapist_ids: [],
                // });
                setCombindFilters({
                    ...combindFilters,
                    therapist_id: "",
                });

            }
        }
    };

    const onPageChange = (page) => {
        setOffsetCall(true);
        setCSOffset(page * 10);
        setCurrentPage(page + 1);
    };

    useEffect(() => {
        if (init === true && offsetCall === true) {
            _showClinicianFilteredData(CSOffset);
        }
    }, [CSOffset]);

    const handleCombinedFiltersApply = (combinedFiltersToApply: CombinedFiltersToApply) => {
        const { searchUpdatedFilter, scheduleFilter, availabilityFilter } = combinedFiltersToApply;

        const _searchCAData = searchUpdatedFilter ? getSearchCADataFilter(searchUpdatedFilter, searchCAData, selectedTherapist) : searchCAData;
        const _scheduleFilterData = scheduleFilter || scheduleFilterObject;
        const _availabilityFilterData = availabilityFilter ? getAvailibilityFilter(_scheduleFilterData, availabilityFilter) : _scheduleFilterData;

        const _combinedScheduleFilter = {
            ..._scheduleFilterData,
            ..._availabilityFilterData
        };

        const _combinedFilterClone = deepClone(combindFilters);

        const _combinedFilters = {
            ..._combinedFilterClone,
            filters: _searchCAData?.filters,
            schedule_request: _combinedScheduleFilter,
        };

        setCombindFilters(_combinedFilters);

        if (combinedFiltersToApply) {
            if (searchUpdatedFilter) {
                setSearchUpdatedFilter(searchUpdatedFilter);
            }

            if (_combinedScheduleFilter) {
                scheduleFilterObject = _.cloneDeep(_combinedScheduleFilter);
            }

            if (availabilityFilter) {
                handleAvailabilityFilter(availabilityFilter);
            }
        }
    };

    const handleLaterSlot = (therapistInfo:any) => {
        // getStartDateAndTime can take timezone dynamically based on our requirement we are sending practiceTimeZone and userTimeZone
        const userTimeZone = GetUserTimeZone();
        const laterSlotDate = 
            getStartDateAndTime(therapistInfo?.later_slot?.slot_start_date_time, ((isFromQuestionnaire === false &&
                window.location.pathname.includes("clinician-availability") &&
                isFromBookingPage === null) ? practiceTimeZone : userTimeZone) );

            let updatedScheduleFilterObject;
    
            if (selectedTherapist && selectedTherapist !== "") {
                updatedScheduleFilterObject = {
                    ...scheduleFilterObject,
                    start_date: laterSlotDate,
                    therapist_ids: [selectedTherapist],
                };
            } else {
                updatedScheduleFilterObject = {
                    ...scheduleFilterObject,
                    start_date: laterSlotDate,
                };
            }
    
            setScheduleFilterObject(updatedScheduleFilterObject);
            applyCombinedFiltersForScheduleFilterUpdates(
                updatedScheduleFilterObject
            );
    };

    return (
        <>
            <ClicianAvailability
                choices={choices}
                therapistsList={therapistsList}
                dateRequested={dateRequested}
                isLoading={isLoading}
                selectedFilters={selectedFilters}
                isFetching={therapistLoading}
                searchUpdatedFilter={searchUpdatedFilter}
                setSearchUpdatedFilter={setSearchUpdatedFilter} // used in CAFilter
                offset={offset}
                setOffset={setOffset}
                onSelected={onSelectedTherapist}
                scheduleFilterObject={scheduleFilterObject}
                selectedTherapist={selectedTherapist}
                loadMoreResult={() => Logger.log("load more result")}
                handleDateSliderChange={handleDateSliderChange}
                handleCalenderAvailabilityFilter={handleAvailabilityFilter} // used in CAFilter
                calenderServiceFilters={calenderServiceFilters}
                handleScheduleFilterUpdate={handleScheduleFilterUpdate} // used in CAFilter
                onPageChange={onPageChange}
                currentPage={currentPage}
                totalPages={totalNoOfPages}
                clinicianFound={total}
                selectedUserId={selectedUserId || selfUserId}
                isFromQuestionnaire={isFromQuestionnaire || isFromBookingPage}
                updateSlot={_showClinicianFilteredData}
                handleOnclick={handleOnclick}
                setIsWithEmptySlot={setIsWithEmptySlot}
                isWithEmptySlot={isWithEmptySlot}
                isFromMobile={isFromMobile}
                handleCombinedFiltersApply={handleCombinedFiltersApply}
                selectedOption={selectedOption}
                handleSelectedOption={handleSelect}
                handleLaterSlot={handleLaterSlot}
            />
        </>
    );
}
